// extracted by mini-css-extract-plugin
export default {"titleWrap":"titleWrap---kectK","title":"title---zVhfC"};